<template>
  <div v-if="loading" class="page-loading">
    <Loading />
  </div>
  <div class="content w-full">
    <TopNavbar />
    <div class="page-content">
      <DynamicVisibility ref="dynamicVisibility">
        <template #primary>
          <AppOverviewComponent @toggle-visibility="toggleVisibility" />
        </template>

        <template #secondary>
          <div class="wrapper-targets d-grid gap-20">
            <div
              class="targets-div p20 bg-purple-gr rad-10 block-mobile b-shaddow-20"
            >
              <div class="targets-row d-flex align-center">
                <div class="center-flex rad-10">
                  <span class="icon material-icons-outlined c-white">
                    bookmarks
                  </span>
                  <div class="comment c-white">
                    <span class="fs-14">{{ $t("Apps.name") }}</span>
                    <span class="d-block wg-bold fs-14">{{
                      userStatistic.appCount
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="targets-div p20 bg-green-gr rad-10 block-mobile b-shaddow-20"
            >
              <div class="targets-row d-flex align-center">
                <div class="center-flex rad-10">
                  <span class="icon material-icons-outlined c-white">
                    code
                  </span>
                  <div class="comment c-white">
                    <span class="fs-14">{{ $t("Developers.name") }}</span>
                    <span class="d-block wg-bold fs-14">{{
                      userStatistic.developerCount
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="targets-div p20 bg-orange-gr rad-10 block-mobile b-shaddow-20"
            >
              <div class="targets-row d-flex align-center">
                <div class="center-flex rad-10">
                  <span class="icon material-icons-outlined c-white">
                    clear_all
                  </span>
                  <div class="comment c-white">
                    <span class="fs-14">{{ $t("AppLists.name") }}</span>
                    <span class="d-block wg-bold fs-14">{{
                      userStatistic.appListCount
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="targets-div p20 bg-pink-gr rad-10 block-mobile b-shaddow-20"
            >
              <div class="targets-row d-flex align-center c-purple">
                <div class="center-flex rad-10">
                  <span class="icon material-icons-outlined c-white">
                    integration_instructions
                  </span>
                </div>
                <div class="comment c-white">
                  <span class="fs-14">{{ $t("DeveloperLists.name") }}</span>
                  <span class="d-block wg-bold fs-14">{{
                    userStatistic.developerListCount
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="wrapper d-grid gap-20">
            <!-- <div class="welcome bg-white rad-10 txt-c-mobile block-mobile b-shaddow-5">
							<div class="intro rad-10 p-20 d-flex space-between bg-eee">
								<div>
									<h4 class="m-0">Hoş Geldiniz</h4>
									<p class="c-grey mt-5">App Follower</p>
								</div>
								<img class="hide-mobile" src="@/assets/img/other/welcome.png" alt="">
							</div>
							<img class="avatar" src="@/assets/img/avatar/avatar.png" >
							<div class="body txt-c d-flex p-20 mb-20 block-mobile">
								<div>Munzir<span class="d-block c-grey fs-12 mt-5">Sayfa Yöneticisi</span></div>
								<div>PANDA<span class="d-block c-grey fs-12  mt-5">Şirketi</span></div>
							</div>
						</div> -->

            <div
              class="latest-brith p-20 bg-white rad-10 b-shaddow-5 txt-c-mobile"
            >
              <div class="head-y d-flex mt-5">
                <span class="material-icons-outlined c-black ml-10">
                  sync_alt
                </span>
                <h4 class="mt-0 mb-10 ml-20">Last Updated</h4>
              </div>
              <TableComponent>
                <template v-slot:table-header>
                  <tr>
                    <th v-for="header in tableAppHeaders" :key="header.key">
                      {{ header.label }}
                    </th>
                  </tr>
                </template>
                <template v-slot:table-body>
                  <tr
                    v-for="(data, index) in filteredLastUpdated"
                    :key="data.id"
                    :class="{ 'zebra-stripe': index % 2 === 0 }"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>
                      <img
                        :src="getItemIcon(data.icon)"
                        alt="App Icon"
                        class="app-icon"
                      />
                    </td>
                    <td>
                      <a :href="data.link" target="_blank">
                        <img
                          :src="getStoreImage(data.platformTypeId)"
                          alt="Platform Icon"
                          class="platform-icon"
                          title="Show Developer On Store"
                        />
                      </a>
                    </td>
                    <td>
                      <a
                        class="clickable-text"
                        :href="
                          $router.resolve({
                            name: 'App',
                            params: { storeId: data.storeId },
                          }).href
                        "
                        @click.stop="
                          handleLinkClick($event, {
                            name: 'App',
                            params: { storeId: data.storeId },
                          })
                        "
                        v-html="data.name || 'N/A'"
                        >
                        </a>
                    </td>
                    <td>
                      <a
                        v-if="data?.developer?.name"
                        :href="
                          $router.resolve({
                            name: 'Developer',
                            params: { storeId: data.developer.storeId },
                          }).href
                        "
                        @click.stop="
                          handleLinkClick($event, {
                            name: 'Developer',
                            params: { storeId: data.developer.storeId },
                          })
                        "
                        style="
                          cursor: pointer;
                          font-weight: bold;
                          color: var(--text-color);
                        "
                      >
                        {{ data.developer.name }}
                      </a>
                      <span v-else>-</span>
                    </td>
                    <td>{{ formatDate(data.lastUpdated) || "N/A" }}</td>
                    <td>{{ formatDate(data.relasedDate) || "N/A" }}</td>
                    <td>{{ data.price || "N/A" }}</td>
                    <td>{{ data.rate || "N/A" }}</td>
                    <td>{{ data.size || "N/A" }}</td>
                    <td>
                      <template v-if="data.status === 1">
                        <span style="color: green">{{
                          $t("Custom.active")
                        }}</span>
                      </template>
                      <template v-else>
                        <span style="color: red">{{
                          $t("Custom.inactive")
                        }}</span>
                      </template>
                    </td>
                  </tr>
                </template>
              </TableComponent>
            </div>

            <div
              class="latest-brith p-20 bg-white rad-10 b-shaddow-5 txt-c-mobile"
            >
              <div class="head-y d-flex mt-5">
                <span class="material-icons-outlined c-black ml-10">
                  publish
                </span>
                <h4 class="mt-0 mb-10 ml-20">Last Published</h4>
              </div>
              <TableComponent>
                <template v-slot:table-header>
                  <tr>
                    <th v-for="header in tableAppHeaders" :key="header.key">
                      {{ header.label }}
                    </th>
                  </tr>
                </template>
                <template v-slot:table-body>
                  <tr
                    v-for="(data, index) in filteredLastPublished"
                    :key="data.id"
                    :class="{ 'zebra-stripe': index % 2 === 0 }"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>
                      <img
                        :src="getItemIcon(data.icon)"
                        alt="App Icon"
                        class="app-icon"
                      />
                    </td>
                    <td>
                      <a :href="data.link" target="_blank">
                        <img
                          :src="getStoreImage(data.platformTypeId)"
                          alt="Platform Icon"
                          class="platform-icon"
                          title="Show Developer On Store"
                        />
                      </a>
                    </td>
                    <td>
                      <a
                        class="clickable-text"
                        :href="
                          $router.resolve({
                            name: 'App',
                            params: { storeId: data.storeId },
                          }).href
                        "
                        @click.stop="
                          handleLinkClick($event, {
                            name: 'App',
                            params: { storeId: data.storeId },
                          })
                        "
                        
                        v-html="data.name || 'N/A'"
                        >
                      </a>
                    </td>
                    <td>
                      <a
                        v-if="data?.developer?.name"
                        :href="
                          $router.resolve({
                            name: 'Developer',
                            params: { storeId: data.developer.storeId },
                          }).href
                        "
                        @click.stop="
                          handleLinkClick($event, {
                            name: 'Developer',
                            params: { storeId: data.developer.storeId },
                          })
                        "
                        style="
                          cursor: pointer;
                          font-weight: bold;
                          color: var(--text-color);
                        "
                      >
                        {{ data.developer.name }}
                      </a>
                      <span v-else>-</span>
                    </td>
                    <td>{{ formatDate(data.lastUpdated) || "N/A" }}</td>
                    <td>{{ formatDate(data.relasedDate) || "N/A" }}</td>
                    <td>{{ data.price || "N/A" }}</td>
                    <td>{{ data.rate || "N/A" }}</td>
                    <td>{{ data.size || "N/A" }}</td>
                    <td>
                      <template v-if="data.status === 1">
                        <span style="color: green">{{
                          $t("Custom.active")
                        }}</span>
                      </template>
                      <template v-else>
                        <span style="color: red">{{
                          $t("Custom.inactive")
                        }}</span>
                      </template>
                    </td>
                  </tr>
                </template>
              </TableComponent>
            </div>

            <div
              class="latest-brith p-20 bg-white rad-10 b-shaddow-5 txt-c-mobile"
            >
              <div class="head-y d-flex mt-5">
                <span class="material-icons-outlined c-black ml-10">
                  trending_up
                </span>
                <h4 class="mt-0 mb-10 ml-20">Top Apps</h4>
              </div>
              <TableComponent>
                <template v-slot:table-header>
                  <tr>
                    <th v-for="header in tableAppHeaders" :key="header.key">
                      {{ header.label }}
                    </th>
                  </tr>
                </template>
                <template v-slot:table-body>
                  <tr
                    v-for="(data, index) in filteredTopApps"
                    :key="data.item.id"
                    :class="{ 'zebra-stripe': index % 2 === 0 }"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>
                      <img
                        :src="getItemIcon(data.item.icon)"
                        alt="App Icon"
                        class="app-icon"
                      />
                    </td>
                    <td>
                      <a :href="data.item.link" target="_blank">
                        <img
                          :src="getStoreImage(data.item.platformTypeId)"
                          alt="Platform Icon"
                          class="platform-icon"
                          title="Show Developer On Store"
                        />
                      </a>
                    </td>
                    <td>
                      <a
                        class="clickable-text"
                        :href="
                          $router.resolve({
                            name: 'App',
                            params: { storeId: data.item.storeId },
                          }).href
                        "
                        @click.stop="
                          handleLinkClick($event, {
                            name: 'App',
                            params: { storeId: data.item.storeId },
                          })
                        "
                        v-html="data.item.name || 'N/A'"
                        >
                      </a>
                    </td>
                    <td>
                      <a
                        v-if="data.item?.developer?.name"
                        :href="
                          $router.resolve({
                            name: 'Developer',
                            params: { storeId: data.item.developer.storeId },
                          }).href
                        "
                        @click.stop="
                          handleLinkClick($event, {
                            name: 'Developer',
                            params: { storeId: data.item.developer.storeId },
                          })
                        "
                        style="cursor: pointer; font-weight: bold; color: var(--text-color);"
                      >
                        {{ data.item.developer.name }}
                      </a>
                      <span v-else>-</span>
                    </td>
                    <td>{{ formatDate(data.item.lastUpdated) || "N/A" }}</td>
                    <td>{{ formatDate(data.item.relasedDate) || "N/A" }}</td>
                    <td>{{ data.item.price || "N/A" }}</td>
                    <td>{{ data.item.rate || "N/A" }}</td>
                    <td>{{ data.item.size || "N/A" }}</td>
                    <td>
                      <template v-if="data.item.status === 1">
                        <span style="color: green">{{
                          $t("Custom.active")
                        }}</span>
                      </template>
                      <template v-else>
                        <span style="color: red">{{
                          $t("Custom.inactive")
                        }}</span>
                      </template>
                    </td>
                  </tr>
                </template>
              </TableComponent>
            </div>

            <div
              class="latest-brith p-20 bg-white rad-10 b-shaddow-5 txt-c-mobile"
            >
              <div class="head-y d-flex mt-5">
                <span class="material-icons-outlined c-black ml-10">
                  stacked_line_chart
                </span>
                <h4 class="mt-0 mb-10 ml-20">Top Developers</h4>
              </div>
              <TableComponent>
                <template v-slot:table-header>
                  <tr>
                    <th
                      v-for="header in tableDeveloperHeaders"
                      :key="header.key"
                    >
                      {{ header.label }}
                    </th>
                  </tr>
                </template>
                <template v-slot:table-body>
                  <tr
                    v-for="(data, index) in filteredTopDevelopers"
                    :key="data.item.id"
                    :class="{ 'zebra-stripe': index % 2 === 0 }"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>
                      <div class="developer-icon" v-if="data.item.icon">
                        <img :src="data.item.icon" :alt="name" />
                      </div>
                      <div v-else class="developer-icon no-icon">
                        <span class="material-symbols-outlined">
                          code_blocks
                        </span>
                      </div>
                    </td>
                    <td>
                      <span @click="openLink(data.item.link)">
                        <img
                          :src="getStoreImage(data.item.platformTypeId)"
                          alt="Platform Icon"
                          class="platform-icon"
                        />
                      </span>
                    </td>
                    <td>
                      <span
                        class="clickable-text"
                        @click="handleShowDeveloper(data.item.storeId)"
                        v-html="data.item.name || 'N/A'"
                        >
                      </span>
                    </td>
                    <td>{{ data.item?.appCount || "" }}</td>
                  </tr>
                </template>
              </TableComponent>
            </div>
          </div>
        </template>
      </DynamicVisibility>
    </div>
  </div>
</template>

<script>
import TopNavbar from "@/components/user/layout/TopNavbar.vue";
import DynamicVisibility from "@/components/custom/visibility/DynamicVisibility.vue";
import AppOverviewComponent from "../app/AppOverviewComponent.vue";
import Loading from "@/components/user/layout/LoadingComponent.vue";
import TableComponent from "@/components/custom/table/TableComponent.vue";
import {
  getLastPublished,
  getLastUpdated,
  getTopApps,
  getTopDevelopers,
  getUserStatistic,
} from "@/api/statistic.api";
import { storeImage } from "@/ultis/user/functions/storePlatform";

export default {
  name: "DashboardComponent",
  components: {
    TopNavbar,
    AppOverviewComponent,
    DynamicVisibility,
    Loading,
    TableComponent,
  },
  data() {
    return {
      loading: false,
      userStatistic: [],
      lastUpdated: [],
      lastPublished: [],
      topApps: [],
      topDevelopers: [],
      tableAppHeaders: [
        { key: "index", label: this.$t("Table.index") },
        { key: "icon", label: this.$t("Table.icon") },
        { key: "platform", label: this.$t("Table.platform") },
        { key: "name", label: this.$t("Table.name") },
        { key: "developer", label: this.$t("Table.developer") },
        { key: "lastUpdated", label: this.$t("Table.lastUpdated") },
        { key: "releaseDate", label: this.$t("Table.releaseDate") },
        { key: "price", label: this.$t("Table.price") },
        { key: "rate", label: this.$t("Table.rate") },
        { key: "size", label: this.$t("Table.size") },
        { key: "status", label: this.$t("Table.status") },
      ],
      tableDeveloperHeaders: [
        { key: "index", label: this.$t("Table.index") },
        { key: "icon", label: this.$t("Table.icon") },
        { key: "platform", label: this.$t("Table.platform") },
        { key: "name", label: this.$t("Table.name") },
        { key: "appCount", label: this.$t("Table.appCount") },
      ],
    };
  },
  async created() {
    this.loading = true;
    await Promise.all([
      this.getLastUpdated(),
      this.getLastPublished(),
      this.getTopApps(),
      this.getTopDevelopers(),
      this.getUserStatistic(),
    ]);
    this.loading = false;
  },
  computed: {
    filteredTopApps() {
      if (!this.topApps) return [];
      let items = [...this.topApps];
      return items;
    },
    filteredTopDevelopers() {
      if (!this.topDevelopers) return [];
      let items = [...this.topDevelopers];
      return items;
    },
    filteredLastUpdated() {
      if (!this.lastUpdated) return [];
      let items = [...this.lastUpdated];
      return items;
    },
    filteredLastPublished() {
      if (!this.lastPublished) return [];
      let items = [...this.lastPublished];
      return items;
    },
  },
  methods: {
    handleLinkClick(event, routeData) {
      const url = this.$router.resolve(routeData).href;
      if (event.ctrlKey || event.metaKey || event.button === 2) {
        window.open(url, "_blank");
        return;
      }
      this.$router.push(routeData);
    },
    async getLastUpdated() {
      try {
        const response = await getLastUpdated();
        if (response.data.status) {
          this.lastUpdated = response.data.data;
        } else {
          this.lastUpdated = [];
        }
      } catch (error) {
        this.lastUpdated = [];
      }
    },
    async getLastPublished() {
      try {
        const response = await getLastPublished();
        if (response.data.status) {
          this.lastPublished = response.data.data;
        } else {
          this.lastPublished = [];
        }
      } catch (error) {
        this.lastPublished = [];
      }
    },
    async getTopApps() {
      try {
        const response = await getTopApps();
        if (response.data.status) {
          this.topApps = response.data.data;
        } else {
          this.topApps = [];
        }
      } catch (error) {
        this.topApps = [];
      }
    },
    async getTopDevelopers() {
      try {
        const response = await getTopDevelopers();
        if (response.data.status) {
          this.topDevelopers = response.data.data;
        } else {
          this.topDevelopers = [];
        }
      } catch (error) {
        this.topDevelopers = [];
      }
    },
    async getUserStatistic() {
      try {
        const response = await getUserStatistic();
        if (response.data.status) {
          this.userStatistic = response.data.data;
        } else {
          this.userStatistic = [];
        }
      } catch (error) {
        this.userStatistic = [];
      }
    },
    async handleShowApp(storeId) {
      this.$router.push({
        name: "App",
        params: { storeId: storeId },
      });
    },
    async handleShowDeveloper(storeId) {
      this.$router.push({
        name: "Developer",
        params: { storeId: storeId },
      });
    },
    openLink(link) {
      if (link) {
        window.open(link, "_blank", "noopener,noreferrer");
      }
    },
    getStoreImage(platformTypeId) {
      return storeImage(platformTypeId);
    },
    getItemIcon(icon) {
      return icon || require("@/assets/img/developer/developer.png");
    },
    formatDate(date) {
      if (!date) return "";
      const locale = localStorage.getItem("localeTime") || "en-US";
      return new Date(date).toLocaleDateString(locale);
    },
    toggleVisibility(visible) {
      this.$refs.dynamicVisibility.toggle(visible);
    },
  },
};
</script>

<style>
.wrapper {
  grid-template-columns: none !important;
}

.latest-brith {
  max-height: none !important;
  min-height: none !important;
}

.table-container {
  padding: 0%;
}

.developer-icon {
  width: 40px;
  height: 40px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f5f5f5;
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.developer-icon span {
  font-size: 16px;
}

.developer-icon.no-icon {
  background: #fff6ee;
  color: var(--logo-color);
}

.developer-icon img {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  object-fit: cover;
}

@media (max-width: 640px) {
  .developer-icon {
    width: 35px;
    height: 35px;
  }
}
</style>
